module.exports = __webpack_public_path__ + "static/media/delete-white.dfe5007e.svg";